// Reusable empty-state — the 5 demo-visible zero-states share this shape.
//
// Per tenant-shell-strings.md §"Empty states". Per-route copy comes from
// i18n; this component is layout-only.

import type { ReactNode } from 'react';
import styles from './EmptyState.module.css';

export interface EmptyStateProps {
  eyebrow: string;
  headline: string;
  body: string;
  /** Primary action — usually a Button with a route navigation. */
  primary?: ReactNode;
  /** Secondary action — usually a ghost Button or link. */
  secondary?: ReactNode;
  /** Extra content slot (e.g. the 8-domain teaser grid on /frameworks). */
  trailing?: ReactNode;
}

export function EmptyState({
  eyebrow,
  headline,
  body,
  primary,
  secondary,
  trailing,
}: EmptyStateProps) {
  return (
    <section className={styles.section}>
      <span className={styles.eyebrow}>{eyebrow}</span>
      <h1 className={styles.headline}>{headline}</h1>
      <p className={styles.body}>{body}</p>
      {(primary || secondary) && (
        <div className={styles.actions}>
          {primary}
          {secondary}
        </div>
      )}
      {trailing && <div className={styles.trailing}>{trailing}</div>}
    </section>
  );
}
